import { jsx } from 'react/jsx-runtime';
import React from 'react';
import { ListItem, DropdownItemStyle, DropdownItemAnchorStyle, DropdownItemNavLinkStyle } from './DropdownItem.styles.js';
export { ListItem } from './DropdownItem.styles.js';

const DropdownItem = React.forwardRef(function DropdownItem(props, ref) {
    return (jsx(ListItem, Object.assign({ ref: ref }, { children: jsx(DropdownItemStyle, Object.assign({ tabIndex: 0, type: "button" }, props, { children: props.children })) })));
});
const DropdownItemAnchor = (props) => (jsx(ListItem, { children: jsx(DropdownItemAnchorStyle, Object.assign({}, props, { children: props.children })) }));
const DropdownItemNavLink = (props) => {
    return (jsx(ListItem, { children: jsx(DropdownItemNavLinkStyle, Object.assign({}, props, { children: props.children })) }));
};

export { DropdownItem, DropdownItemAnchor, DropdownItemNavLink };
